module.exports = __webpack_public_path__ + "img/header_mobile.38293074.jpg";